export interface TokeetCreditChargeResponse {
  stripe_price_id: string //  "tokeet_ai_v1",
  unit_price: number //  0.05,
  stripe_sub_id: string //  "sub_1PH0ClA5HTBpEcXRCSI248yG",
  attributes: any //  {},
  status: number //  1,
  cycle_start: number //  1715850146,
  cycle_end: number //  1718528546,
  account: number //  1715083186.2763,
  available: number //  1398,
  updates: any[] //  [],
  metadata: any //  {},
  pkey: string //  "354ad1da-ba77-4f32-b0cf-380c1e3c6e2b-tk2",
  used: number //  0,
  rolled_over: number //  1398,
  stripe_amount_paid: number
  archived: number //  0,
  product: string //  "tokeet_ai",
  created: number //  1715855402
}

export function getSMSCreditBalance(data: TokeetCreditChargeResponse | undefined) {
  if (!data) return 0
  return Math.round(((data.available - data.used) / 100) * 100) / 100
}
export interface TokeetCreditChargeLogResponse {
  pkey: string // "ee2b96b1-991b-4701-8919-80402e06093a",
  rolled_over: number // 299,
  used: number // 602,
  cycle_start: number // 1715175857,
  subscription_id: string // "ee08b32f-77d8-4a2a-ac31-b16ae4477526",
  stripe_sub_id: string // "sub_1PE9LIA5HTBpEcXRd5bGcDcr",
  metadata: {
    excerpt: string // "Welcome to our rental",
    guestId: string // "120jklasdflkj",
    inquiryId: string // "3kjhaskjdf"
    rentalId: string // "3kjhaskjdf"
  } & {
    guest_id: string
    from: number | string
    rental_id: string
    inquiry_id: string
    to: number | string
    type: string
    message: string
    channel: string
    external_id: string
  }

  usage: {
    idempotency_key: string // "lkw2512saetj2222",
    time: number // 1715766394,
    value: number // 1
  }
  account: number // 1715083186.2763,
  product: string // "tokeet_ai",
  created: number // 1715766394,
  available: number // 2000,
  ttl: number // null,
  cycle_end: number // 1717854257
}
